import React from "react";
import { LockedRaffleWheel } from "@/apps/raffle/components/RaffleWheel/LockedRaffleWheel";
import { RaffleWheel } from "@/apps/raffle/components/RaffleWheel/RaffleWheel";
import { useRafflePageContext } from "./RafflePageContext";
import cls from "./styles.module.scss";

export const RaffleWheelSection = () => {
  const {
    currentParticipantIndex,
    isParticipationComplete,
    participants,
  } = useRafflePageContext();

  return (
    <div className={cls.wheelCard}>
      {!isParticipationComplete && <LockedRaffleWheel />}
      {isParticipationComplete && participants.length > 0 && (
        <RaffleWheel
          participants={participants}
          currentParticipantIndex={currentParticipantIndex}
        />
      )}
    </div>
  );
};
